export const managementInformationAreaPathName = 'ledelsesinformation';
